import type { History } from '.';
import { HistoryDeathRecord, HistoryDuoRecord } from './history.ruleset';

/**
 * Create death record to history state
 */
export function addDeathRecord(
  state: History.MutableState,
  record: Omit<HistoryDeathRecord, 'type'>,
) {
  state.history.push({ type: 'death', ...record });
}

/**
 * Create duo record to history  player state
 */
export function addPlayerDuoRecord(
  state: History.MutableState,
  player: Omit<HistoryDuoRecord, 'type'>,
) {
  state.history.push({ type: 'duo', ...player });
}
